module.exports = __webpack_public_path__ + "img/myinvestor.1c4fce02.png";